enum Environment {
    DEVELOPMENT = 'development',    // feature branch
    ALPHA = 'alpha',                // alpha branch
    PRODUCTION = 'production',      // main branch
    TEST = 'test',                  // test branch
    UAT = 'uat',                    // uat branch
}

export { Environment };
